import { useAsyncEffect } from 'ahooks';
import dayjs from 'dayjs';
import { useState } from 'react';
import { getResourceCertificate } from '../api/server';
import { defaultConfig } from '../dataFlow';
import { RecognizeObjectType } from '../interface/api';
import type { ICertificateConfigInfo, IUseCaetConfigProps, IUseCaetConfigReturn } from '../interface/caetConfig';

const useCaetConfig = (data: IUseCaetConfigProps): IUseCaetConfigReturn => {
    const { objType = RecognizeObjectType.COURSE, isComplete, id } = data;
    const [certificateConfig, setCertificateConfig] = useState<ICertificateConfigInfo>({
        ...defaultConfig,
    });

    const reload = async () => {
        const {
            user_name,
            obj_info,
            names = [],
            certificate_url = '',
            receive_ts,
        } = await getResourceCertificate({
            obj_type: objType,
            obj_id: id,
        });
        setCertificateConfig({
            userName: user_name,
            title: obj_info.name,
            subTitle: names?.[0]?.name || '',
            qr: certificate_url || obj_info.url || '',
            link: certificate_url,
            theme: '',
            date: receive_ts || isComplete ? String(dayjs().unix()) : '',
        });
    };
    const updateConfigProperty = (info: Partial<ICertificateConfigInfo>) => {
        setCertificateConfig((prev) => ({ ...prev, ...info }));
    };
    const onInit = async () => {
        await reload();
    };
    useAsyncEffect(async () => {
        await onInit();
    }, []);
    return {
        certificateConfig,
        reload,
        updateConfigProperty,
    };
};

export { useCaetConfig };
